/** Display order / line-item status as Initcap (e.g. pending → Pending). */
export function formatOrderStatus(status) {
  const t = String(status || '').trim().toLowerCase();
  if (!t) return '';
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export default formatOrderStatus;
